import { SelectOption } from "components/forms/Select/Select";
import { useMemo } from "react";
import { useReportsMetaSelector } from "store";

// const GLOBAL_ITEMS = "General";

export const useCharacteristics = (): (string | SelectOption)[] => {
  const { assetClasses, characteristics } = useReportsMetaSelector();

  return useMemo(() => {
    const result: (string | SelectOption)[] = [...characteristics];
    assetClasses.forEach((asset) => {
      // result =  result.concat(asset.characteristics);
      if (asset.characteristics.length) {
        result.push({
          key: asset.title,
          value: asset.title,
          text: asset.title,
          role: "category",
        });

        asset.characteristics.forEach((item) =>
          result.push({
            key: asset.id + "." + item,
            value: item.toString(),
            text: item.toString(),
          })
        );
      }
    });

    // const somethingFromOre = measureClasses.map((mc) => mc.title);
    // console.log("somethingFromOre", somethingFromOre);

    // if (somethingFromOre.length > 0) {
    //   result.push({
    //     key: GLOBAL_ITEMS,
    //     value: GLOBAL_ITEMS,
    //     text: GLOBAL_ITEMS,
    //     role: "category",
    //   });
    //   somethingFromOre.forEach((item) => result.push(item));
    // }

    return result;
  }, [assetClasses, characteristics]);
};
